interface TableSkeletonProps {
  count?: number;
}

const TableSkeleton = ({
  count = 3,
}: TableSkeletonProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 p-5 md:grid-cols-2 xl:grid-cols-3">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="overflow-hidden rounded-xl border border-stroke bg-white dark:border-strokedark dark:bg-boxdark"
        >
          <div className="animate-pulse p-5">
            <div className="flex justify-between">
              <div>
                <div className="mb-2 h-3 w-24 rounded bg-gray-2 dark:bg-meta-4" />
                <div className="h-5 w-36 rounded bg-gray-2 dark:bg-meta-4" />
              </div>

              <div className="h-7 w-20 rounded-full bg-gray-2 dark:bg-meta-4" />
            </div>

            <div className="my-6 flex items-center justify-between">
              <div className="h-20 w-24 rounded-xl bg-gray-2 dark:bg-meta-4" />

              <div className="space-y-2">
                <div className="h-4 w-24 rounded bg-gray-2 dark:bg-meta-4" />
                <div className="h-3 w-16 rounded bg-gray-2 dark:bg-meta-4" />
              </div>
            </div>

            <div className="mb-4 h-10 rounded bg-gray-2 dark:bg-meta-4" />

            <div className="flex gap-2 border-t border-stroke pt-4 dark:border-strokedark">
              <div className="h-10 flex-1 rounded bg-gray-2 dark:bg-meta-4" />
              <div className="h-10 w-28 rounded bg-gray-2 dark:bg-meta-4" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TableSkeleton;